import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    offer_terms: [],
    offer_termsCount: 0,
    offer_term: {},
    offer_termSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getOffer_terms(state) {
      return state.offer_terms
    },
    getOffer_termsCount(state) {
      return state.offer_termsCount
    },
    getOffer_term(state) {
      return state.offer_term
    },
    getOffer_termSaveStatus(state) {
      return state.offer_termSave
    },
  },
  mutations: {
    OFFER_TERMS_LIST(state, data) {
      state.offer_terms = data
    },
    OFFER_TERM_VIEW(state, data) {
      state.offer_term = data
    },
    OFFER_TERMS_COUNT(state, data) {
      state.offer_termsCount = data
    },
    OFFER_TERM_SAVE(state, data) {
      state.offer_termSave = data
    },
  },
  actions: {
    offer_termsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/offer_terms/getData', data)
        .then(response => {
          commit('OFFER_TERMS_LIST', response.data.data)
          commit('OFFER_TERMS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    offer_termView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'offer_terms.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/offer_terms/getData', data)
        .then(response => {
          commit('OFFER_TERM_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    offer_termSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/offer_terms/saveData', data)
        .then(response => {
          commit('OFFER_TERM_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
